import type { FollowStatus } from '@/components/OrganizerCard/types';
import { DEFAULT_FOLLOW_STATUS_RESPONSE } from '@/components/_shared/buttons/FollowButton/utils';
import type { OrganizerFollowStatusResponse } from '@/types/organizerFollow';

export const fetchOrganizerFollowStatusExpansion = async (organizerId: string | null): Promise<FollowStatus> => {
  if (!organizerId) {
    console.error('FollowButton: Organizer ID is missing');
    return DEFAULT_FOLLOW_STATUS_RESPONSE;
  }

  try {
    const response = await fetch(`/e/api/organizer/${encodeURIComponent(organizerId)}/follow-status`);

    if (!response.ok) {
      console.error('FollowButton: Follow status request failed', {
        organizerId,
        status: response.status,
      });
      return DEFAULT_FOLLOW_STATUS_RESPONSE;
    }

    const payload = (await response.json()) as Partial<OrganizerFollowStatusResponse>;
    return {
      followedByYou: payload.followedByYou === true,
      numFollowers: payload.numFollowers ?? DEFAULT_FOLLOW_STATUS_RESPONSE.numFollowers,
    };
  } catch (error) {
    console.error('FollowButton: Follow status request failed', {
      organizerId,
      error,
    });
    return DEFAULT_FOLLOW_STATUS_RESPONSE;
  }
};
